import { Text, Button } from '@ui-component-library';

import { useUserSettings } from './UserSettingsContext';
import { isPlusSubscription } from './components/Settings.types';
import PlusSubscriptionRow from './components/SubscriptionComponents';




type UserReceiptRow = {

  id: number;

  issued_at?: string | null;

  title?: string;

  description?: string;

  amount_sek?: string | null;

};



function formatReceiptDate(iso: string | null | undefined): string {

  if (!iso) return '—';

  const d = new Date(iso);

  if (Number.isNaN(d.getTime())) return iso;

  return d.toLocaleDateString('sv-SE');

}



export default function SubscriptionSettings() {
  const { userData, refetchUserData } = useUserSettings();
  const plusSubscriptions = userData?.plus_subscriptions;
  const plusSubs = Array.isArray(plusSubscriptions)
    ? plusSubscriptions.filter(isPlusSubscription)
    : [];
  const isPlus = userData?.is_plus || userData?.subscription === 'Treebula_Plus_year';



  const receipts = (

    Array.isArray(userData?.user_receipts) ? userData.user_receipts : []

  ) as UserReceiptRow[];



  return (

    <div className="w-full max-w-[700px] px-2 mx-auto space-y-6">

      <section className="rounded-2xl bg-white-50 border-solid border-1 border-cloud-500 p-4">

        {/* Header */}

        <div className="p-6 border-b border-cloud-200 bg-cloud-50/30">

          <Text variant="text-base/leading-normal/medium" className="text-charcoal-1000">

            Dina prenumerationer

          </Text>

          <Text variant="text-sm/leading-normal/normal" className="text-charcoal-600">

            Hantera dina prenumerationer

          </Text>

        </div>

        <div className="divide-y divide-cloud-200">
          {plusSubs.length > 0 ? (
            <>
              {plusSubs.map((sub) => (
                <PlusSubscriptionRow
                  key={sub.id}
                  sub={sub}
                  onCancelled={() =>{refetchUserData()} }
                />
              ))}
              <div className="p-6">
                <Button
                  variant="primary"
                  size="small"
                  onClick={() => { window.location.href = '/min-skog/?view=pricing'; }}
                >
                  Lägg till fler plus fastigheter
                </Button>
              </div>
            </>
          ) : (
            <>
              <div className="p-6 flex flex-col lg:flex-row lg:items-center lg:justify-between hover:bg-cloud-50/50 transition-colors">
                <div className="flex flex-col gap-1">
                  <Text variant="text-sm/leading-normal/medium" className="text-charcoal-1000">
                    Treebula Plus
                  </Text>
                  {isPlus && (
                    <span className="px-2 py-0.5 rounded-full bg-green-100 text-green-700 text-xs font-medium">
                      Aktiv
                    </span>
                  )}
                </div>

                {userData?.sub_start_time && (
                  <Text variant="text-xs/leading-normal/normal" className="text-charcoal-500">
                    Från: {new Date(userData.sub_start_time as string).toLocaleDateString('sv-SE')}
                  </Text>
                )}

                {userData?.sub_end_time && (
                  <Text variant="text-xs/leading-normal/normal" className="text-charcoal-500">
                    Till: {new Date(userData.sub_end_time as string).toLocaleDateString('sv-SE')}
                  </Text>
                )}

                {!isPlus && (
                  <Text variant="text-xs/leading-normal/normal" className="text-charcoal-500">
                    Ingen aktiv prenumeration
                  </Text>
                )}

                <Button
                  variant="primary"
                  size="small"
                  className="lg:mt-0 mt-2"
                  onClick={() => {
                    window.location.href = '/min-skog/?view=pricing';
                  }}
                >
                  {isPlus ? 'Lägg till fler plus fastigheter' : 'Uppgradera'}
                </Button>
              </div>

              {!isPlus && (
                <div className="p-6 flex items-center justify-between">
                  <div className="flex flex-col gap-1">
                    <Text variant="text-sm/leading-normal/medium" className="text-charcoal-1000">
                      Treebula Bas
                    </Text>
                    <Text variant="text-xs/leading-normal/normal" className="text-charcoal-500">
                      Ingår i ditt konto
                    </Text>
                  </div>
                  <span className="text-xs text-charcoal-400 font-medium italic">Standard</span>
                </div>
              )}
            </>
          )}
        </div>

      </section>



      <section className="rounded-2xl bg-white-50 border-solid border-1 border-cloud-500 p-4">

        <div className="p-6 border-b border-cloud-200 bg-cloud-50/30">

          <Text variant="text-base/leading-normal/medium" className="text-charcoal-1000">

            Betalningshistorik

          </Text>

          <Text variant="text-sm/leading-normal/normal" className="text-charcoal-600">

            Ladda ner kvitton och fakturor för dina betalningar

          </Text>

        </div>



        <div className="divide-y divide-cloud-200">

          {receipts.length === 0 ? (

            <div className="p-6">

              <Text variant="text-sm/leading-normal/normal" className="text-charcoal-500">

                Inga kvitton eller fakturor.

              </Text>

            </div>

          ) : (

            receipts.map((r) => (

              <div

                key={r.id}

                className="p-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 hover:bg-cloud-50/50 transition-colors"

              >

                <div className="flex flex-col gap-1 min-w-0">

                  <Text variant="text-sm/leading-normal/medium" className="text-charcoal-1000 truncate">

                    {r.title?.trim() ? r.title : 'Faktura / kvitto'}

                  </Text>

                  <Text variant="text-xs/leading-normal/normal" className="text-charcoal-500">

                    Datum: {formatReceiptDate(r.issued_at ?? undefined)}

                    {r.amount_sek != null && r.amount_sek !== '' ? ` · ${r.amount_sek.replace(".", ",")} kr` : ''}

                  </Text>

                </div>

                <Button variant="secondary" size="small" className="shrink-0" asChild>

                  <a href={`/user-api/user-receipts/${r.id}/download/`} target="_blank" rel="noopener noreferrer">

                    Ladda ner

                  </a>

                </Button>

              </div>

            ))

          )}

        </div>

      </section>

    </div>

  );

}

